<template>
  <table class="table-tab__block table">
    <thead>
      <tr>
        <th style="width: 20%">
          Сумма
          <span v-if="withTaxes !== undefined">
            ({{withTaxes ? $t('form.lot.with-taxes') : $t('form.lot.without-taxes')}})
          </span>
        </th>
        <th>Валюта</th>
      </tr>
    </thead>

    <tbody>
      <template v-for="(item, id) of total">
        <tr class="table-tab__border-top">
          <td>{{item.total | price}}</td>
          <td>{{$t(item.currency.label)}}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
  export default {
    props: {
      total: {
        type: Array,
        required: true
      },

      withTaxes: {
        type: Boolean
      }
    }
  }
</script>

<style lang="scss" scoped>
  caption {
    button {
      font-size: 14px;
    }
  }
</style>
